import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-instructions-list',
  templateUrl: './instructions-list.component.html',
  styleUrls: ['./instructions-list.component.scss'],
  standalone: false,
})
export class InstructionsListComponent implements OnInit {
  @Input() showInstructions: boolean;
  @Input() icon: string;
  @Input() title: string;
  @Input() shortTitle: string;
  @Input() steps: string[];
  @Input() instructionContentClass: string;

  @Input() toggleExpandCollapse: boolean; // Expand Collapse Instruction List Accordion

  constructor() {}

  /**
   * Default On Init
   */
  // TODO: Remove ngOnInit if not needed in future review
  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
  ngOnInit(): void {}

  /**
   * Toggle accordion to expand or collapse the instruction list
   */
  toggleAccordion(): void {
    this.toggleExpandCollapse = !this.toggleExpandCollapse;
  }

  /**
   * Add Track By step to not redraw or re-render list items that have not changed.
   * This improves performance.
   * @param index - Index of step array
   * @param item - step item
   * @returns index
   */
  trackByInstructionsId(index: number, steps: string): string {
    if (steps) {
      return steps;
    } else {
      return String(index);
    }
  }
}
